// src/components/bar/OrderPreparingScreen.js
import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import styles from './OrderPreparing.module.css';

const OrderPreparingScreen = ({ selectedProduct, orderId, onBackToMenu, onPickup }) => {
  const [isReady, setIsReady] = useState(false);
  const [orderStatus, setOrderStatus] = useState(null); // 'pending' | 'preparation' | 'ready'

  // 注文ステータスを監視（注文中 / 作り始めました / 受け取る）
  useEffect(() => {
    if (!orderId) return;

    console.log(`OrderPreparingScreen: 注文 ${orderId} のリアルタイム監視を開始`);

    const db = getDatabase();
    const orderRef = ref(db, `orders/${orderId}`);

    const unsubscribe = onValue(orderRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        console.log('OrderPreparingScreen: 注文データ更新を受信:', data);

        if (data.isReady && !data.isPickedUp) {
          setIsReady(true);
          setOrderStatus('ready');
        } else {
          setIsReady(false);
          setOrderStatus(data.status === 'preparation' ? 'preparation' : 'pending');
        }
      } else {
        setOrderStatus(null);
      }
    }, (error) => {
      console.error('OrderPreparingScreen: 注文データの取得エラー:', error);
    });

    return () => unsubscribe();
  }, [orderId]);

  const statusTitle = isReady ? 'ご注文の準備ができました' : (orderStatus === 'preparation' ? '作り始めました' : '注文中');

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* GIF画像によるローディングアニメーション */}
        <div className={styles.animationContainer}>
          <img
            src="/images/bartender_A.gif"
            alt="バーテンダーが調理中"
            className={styles.animationImage}
          />
        </div>

        <h2 className={styles.title}>
          {statusTitle}
        </h2>

        <p className={styles.description}>
          {isReady
            ? 'カウンターでお受け取りください。'
            : orderStatus === 'preparation'
              ? 'バーテンダーがお客様のドリンクを丁寧に製作しています。しばらくお待ちください。'
              : 'ご注文を受け付けました。スタッフが対応するまで少々お待ちください。'}
        </p>

        {orderId && (
          <p className={styles.orderId}>
            注文ID: {orderId.substring(0, 8)}
          </p>
        )}

        {selectedProduct && (
          <div className={styles.productInfo}>
            <p className={styles.productText}>
              注文商品: <span className={styles.productName}>{selectedProduct.name}</span>
            </p>
          </div>
        )}

        <div className={styles.buttonContainer}>
          {isReady && (
            <button
              onClick={() => {
                if (typeof onPickup === 'function') onPickup();
              }}
              className={`${styles.primaryButton} ${styles.pickupHighlightButton}`}
            >
              受け取る
            </button>
          )}

          <button
            onClick={onBackToMenu}
            className={isReady ? styles.readySecondaryButton : styles.primaryButton}
          >
            メニューへ戻る
            {!isReady && <span className={styles.continuationText}>（注文は継続します）</span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderPreparingScreen;